import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { createSentryConfig } from "../../common/config/sentry";

export function initializeSentry(dsn: string): void {
  if (!dsn) {
    console.warn("Sentry DSN not provided, error tracking disabled");
    return;
  }

  try {
    Sentry.init({
      dsn,
      ...createSentryConfig({
        release: (import.meta.env.VITE_APP_VERSION as string | undefined) || "0.0.0",
        environment: import.meta.env.MODE
      }),
      integrations: [
        new BrowserTracing(),
        new Sentry.Replay({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false
        })
      ],
      // Enable source maps
      attachStacktrace: true,
      beforeSend(event) {
        // Allow events in development for testing
        return event;
      },
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
  } catch (error) {
    console.error("Failed to initialize Sentry:", error);
  }
}

// Custom error boundary component
export const SentryErrorBoundary = Sentry.ErrorBoundary;
